import router from "./router";
import store from "./store";
router.beforeEach(async (to, from, next) => {
    let hasToken = true;//获取token
    if(hasToken){
        var lang;//记录语言
        // 没有参数undefined
        if(to.query.lang == undefined){
            lang = to.query.lang = store.getters.languageType
        }else{
            lang = to.query.lang
        }
        var id= to.query.id;
        await store.dispatch("index/language",{lang:lang})//不管怎么储蓄语言


        if(to.path == '/list'){
            await store.dispatch("index/shopId",{id:id})//不管怎么储蓄语言
        }
        if(to.path == '/position'){
            await store.dispatch("index/positionId",{id:id})//不管怎么储蓄语言
        }
        // 第一次加载域名进来
        document.title =to.meta.title;//设置标题
        if(to.path == '/'){
            next({path:'index',query:{lang:lang}})
        }else{
            if(to.matched.length === 0 ){   
                next({path:'404',query:{msg:'页面数据未找到'}})
            }else{
                next();
            }
            
        }
        next();
    }
})